export class InvoicePdf {
  ref: string;
  language: string;
  link: string;
  credential: string;
  centeraId: string;
  s3Uuid: string;
  name: string;
  size: string;
  content: string;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
